import { Box, Text } from "@mantine/core";

const DetailSection = ({
  title,
  content,
}: {
  title: string;
  content: string;
}) => (
  <Box>
    <Text weight={700} size="sm">
      {title}
    </Text>
    <Text size="sm" color="dimmed">
      {content}
    </Text>
  </Box>
);

export default DetailSection;
